import { Component, OnInit, Pipe, PipeTransform ,OnDestroy } from '@angular/core';
import { FarmService } from 'src/app/services/farm-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swiper from 'swiper';
import { ProcessService } from 'src/app/services/process.service';
import * as moment from 'moment';
import { async } from '@angular/core/testing';
import { getDate } from 'ngx-bootstrap/chronos/utils/date-getters';

// import { $ } from 'protractor';



declare var $: any;

@Component({
  selector: 'smart-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(
  
  ) {

  }

  ngOnInit() {

  
  }

  
}
